import get from 'lodash.get';

const getNavigationContent = (state) => {
  const content = get(state, 'content');
  return content;
};

export default { getNavigationContent };
